import { useCallback, useState } from 'react';
import { toast } from 'sonner';

import { paymentApi } from '@/api/payment';

export function useBillingPortal() {
    const [isPortalLoading, setIsPortalLoading] = useState(false);

    const openBillingPortal = useCallback(async () => {
        try {
            setIsPortalLoading(true);
            const response = await paymentApi.createPortalSession();
            window.location.href = response.url;
        } catch (error) {
            console.error('Portal error:', error);
            toast.error('Erro ao acessar o portal de Assinatura');
            setIsPortalLoading(false);
        }
    }, []);

    return {
        isPortalLoading,
        openBillingPortal,
    };
}
